import { Form, Input, Button } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";

const onFinish = (values: any) => {
  fetch('http://sprintly.co:9080/api/sendMessage', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Origin':'false'
    },
    body: JSON.stringify({
      name: values.name,
      email: values.email,
      message: values.message
    })
  });
  console.log('Success:', values);
  alert.show("message sent");
};

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo);
};

const ContactForm = (props) => {
  return (
           <Form
           className="contact-form"
           name="basic"
           // labelCol={{ span: 8 }}
           // wrapperCol={{ span: 16 }}
           initialValues={{ remember: true }}
           layout="vertical"
           onFinish={onFinish}
           onFinishFailed={onFinishFailed}
           autoComplete="off"

         >
           <Form.Item
             label="Name"
             name="name"
             rules={[{ required: true, message: 'Please input your name!' }]}
           >
             <Input />
           </Form.Item>

           <Form.Item
             label="E-Post"
             name="email"
             rules={[{ required: true, message: 'Please input your e-mail!' }]}
           >
             <Input />
           </Form.Item>
           <Form.Item
             // label="Message"
             name="message"
           >
             <TextArea className="msgBox" rows={8} placeholder="Message"/>
           </Form.Item>
           <Form.Item >
             <Button  htmlType="submit"  shape="circle" className="contact-btn" >
               Send
             </Button>
           </Form.Item>
         </Form>
        )


}

export default ContactForm;
